// src/pages/EventList.js
import React, { useEffect, useState } from 'react';
import {
    collection, getDocs, query, orderBy, where
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import EventCard from '../components/EventCard';

export default function EventsList() {
    const [upcoming, setUpcoming] = useState([]);
    const [past, setPast] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const eventsRef = collection(db, 'events');
                // event_date is saved as an ISO 8601 string; lexicographic compare works chronologically
                const nowIso = new Date().toISOString();

                // Upcoming (>= now), soonest first
                const upcomingQ = query(
                    eventsRef,
                    where('event_date', '>=', nowIso),
                    orderBy('event_date', 'asc')
                );

                // Past (< now), most recent first
                const pastQ = query(
                    eventsRef,
                    where('event_date', '<', nowIso),
                    orderBy('event_date', 'desc')
                );

                const [upSnap, pastSnap] = await Promise.all([getDocs(upcomingQ), getDocs(pastQ)]);
                setUpcoming(upSnap.docs.map(d => ({ id: d.id, ...d.data() })));
                setPast(pastSnap.docs.map(d => ({ id: d.id, ...d.data() })));
            } catch (err) {
                console.error('Error fetching events:', err);
                setError('Failed to load events.');
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    if (loading) return <p>Loading events...</p>;
    if (error) return <p>{error}</p>;

    const hasUpcoming = upcoming.length > 0;
    const hasPast = past.length > 0;

    return (
        <div className="outer-event-container">
            <div className="event-container fade-in">
                {/* Upcoming */}
                {hasUpcoming && (
                    <>
                        <h2 style={{ margin: '12px 0' }}>Upcoming Events</h2>
                        {upcoming.map((event, index) => (
                            <EventCard key={event.id} event={event} index={index} />
                        ))}
                    </>
                )}

                {/* Past */}
                {hasPast && (
                    <>
                        <h2 style={{ margin: '24px 0 12px' }}>Past Events</h2>
                        {past.map((event, index) => (
                            <EventCard key={event.id} event={event} index={index} />
                        ))}
                    </>
                )}

                {!hasUpcoming && !hasPast && <p>No events found.</p>}
            </div>
        </div>
    );
}
